import { useSyncExternalStore } from 'react';
import { gotoMetricsStore, type GotoMetrics } from './gotoMetrics.js';

export function useGotoMetrics(): GotoMetrics | null {
  return useSyncExternalStore(
    gotoMetricsStore.subscribe,
    () => gotoMetricsStore.getState().metrics,
    () => null,
  );
}
